import { imageForDetectionID } from '../api/faces'
export function updateFaceWithFilteredFace ({ face, filteredFace }) {
  if (filteredFace) {
    face.last_seen_datetime = filteredFace.last_seen_timestamp
    face.last_seen_camera_description = filteredFace.last_seen_camera_description
    face.last_seen_preview = imageForDetectionID(filteredFace.detection_id)
    face.last_seen_frame_uri = imageForDetectionID(filteredFace.detection_id, { fullFrame: true })
    face.last_seen_camera_uuid = filteredFace.last_seen_camera_uuid
    face.last_seen_detection_id = filteredFace.detection_id
  } else {
    face.last_seen_datetime = undefined
    face.last_seen_camera_description = undefined
    face.last_seen_preview = undefined
    face.last_seen_frame_uri = undefined
    face.last_seen_camera_uuid = undefined
    face.last_seen_detection_id = undefined
  }
  return face
}
